/**
 * Event types for the application
 */
export enum EventTypes {
  VideoUploaded = "VideoUploaded",
  ModelCreated = "ModelCreated",
}
